import { ComponentProps } from 'react';

function CalendarIllustration(props: ComponentProps<'svg'>) {
  return (
    <svg
      viewBox='0 0 247 247'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M123.5 247C191.431 247 246.5 191.707 246.5 123.5C246.5 55.2928 191.431 0 123.5 0C55.569 0 0.5 55.2928 0.5 123.5C0.5 191.707 55.569 247 123.5 247Z'
        className='fill-mono-color-lightest'
      />
      <path
        d='M224.75 43H23.75V206H224.75V43Z'
        className='fill-mono-color-light'
      />
      <path
        d='M73.7912 66.6445H37.1611V90.4541H73.7912V66.6445Z'
        className='fill-mono-color-white'
      />
      <path
        d='M119.307 66.6445H82.6768V90.4541H119.307V66.6445Z'
        className='fill-mono-color-white'
      />
      <path
        d='M164.822 66.6445H128.192V90.4541H164.822V66.6445Z'
        className='fill-mono-color-white'
      />
      <path
        d='M210.338 66.6445H173.708V90.4541H210.338V66.6445Z'
        className='fill-mono-color-white'
      />
      <path
        d='M73.7912 100.344H37.1611V124.153H73.7912V100.344Z'
        className='fill-mono-color-white'
      />
      <path
        d='M119.307 100.344H82.6768V124.153H119.307V100.344Z'
        className='fill-mono-color-white'
      />
      <path
        d='M164.822 100.344H128.192V124.153H164.822V100.344Z'
        className='fill-mono-color-white'
      />
      <path
        d='M210.338 100.344H173.708V124.153H210.338V100.344Z'
        className='fill-mono-color-white'
      />
      <path
        d='M73.7912 134.043H37.1611V157.852H73.7912V134.043Z'
        className='fill-mono-color-white'
      />
      <path d='M73.7912 168H37.1611V191.81H73.7912V168Z' className='fill-mono-color-white' />
      <path
        d='M119.307 134.043H82.6768V157.852H119.307V134.043Z'
        className='fill-mono-color-white'
      />
      <path d='M119.307 168H82.6768V191.81H119.307V168Z' className='fill-mono-color-white' />
      <path
        d='M164.822 134.043H128.192V157.852H164.822V134.043Z'
        className='fill-mono-color-white'
      />
      <path d='M164.822 168H128.192V191.81H164.822V168Z' className='fill-mono-color-white' />
      <path
        d='M210.338 134.043H173.708V157.852H210.338V134.043Z'
        className='fill-mono-color-white'
      />
      <path d='M210.338 168H173.708V191.81H210.338V168Z' className='fill-mono-color-white' />
      <path
        d='M76.1312 57.3035C79.1658 57.3035 81.6257 54.8435 81.6257 51.809C81.6257 48.7744 79.1658 46.3145 76.1312 46.3145C73.0967 46.3145 70.6367 48.7744 70.6367 51.809C70.6367 54.8435 73.0967 57.3035 76.1312 57.3035Z'
        className='fill-mono-color-white'
      />
      <path
        d='M166.973 57.3034C170.008 57.3034 172.468 54.8435 172.468 51.8089C172.468 48.7744 170.008 46.3145 166.973 46.3145C163.938 46.3145 161.479 48.7744 161.479 51.8089C161.479 54.8435 163.938 57.3034 166.973 57.3034Z'
        className='fill-mono-color-white'
      />
      <path
        d='M78.3292 28H73.9336V53.2747H78.3292V28Z'
        className='fill-mono-color-light'
      />
      <path
        d='M169.171 28H164.775V53.2747H169.171V28Z'
        className='fill-mono-color-light'
      />
      <path
        d='M200.307 78.5492C200.305 80.5384 199.586 82.4601 198.281 83.9612C196.975 85.4623 195.172 86.442 193.203 86.7202C191.233 86.9985 189.229 86.5566 187.559 85.4758C185.889 84.395 184.665 82.7478 184.113 80.837C183.56 78.9261 183.715 76.88 184.55 75.0745C185.385 73.269 186.843 71.8254 188.657 71.009C190.471 70.1926 192.519 70.0582 194.424 70.6305C196.329 71.2029 197.963 72.4435 199.027 74.1244C199.865 75.4481 200.309 76.9827 200.307 78.5492Z'
        className='fill-brand-color-secondary-light'
      />
      <path
        d='M199.026 74.1241L190.872 82.2764C190.36 81.483 187.505 77.7959 187.505 77.7959C187.871 77.4261 188.261 77.0814 188.674 76.7642L191.041 79.921L198.071 72.8906C198.428 73.2707 198.748 73.6837 199.026 74.1241Z'
        className='fill-mono-color-white'
      />
      <path
        d='M109.276 112.248C109.274 114.238 108.554 116.159 107.249 117.66C105.944 119.162 104.141 120.141 102.171 120.419C100.202 120.698 98.1978 120.256 96.5279 119.175C94.8579 118.094 93.6341 116.447 93.0813 114.536C92.5284 112.625 92.6837 110.579 93.5186 108.774C94.3535 106.968 95.8119 105.525 97.6259 104.708C99.4398 103.892 101.487 103.757 103.393 104.33C105.298 104.902 106.932 106.143 107.996 107.824C108.834 109.147 109.278 110.682 109.276 112.248Z'
        className='fill-brand-color-secondary-light'
      />
      <path
        d='M107.995 107.825L99.8412 115.978C99.3287 115.184 96.4736 111.497 96.4736 111.497C96.8395 111.127 97.23 110.783 97.6423 110.465L100.01 113.622L107.04 106.592C107.397 106.972 107.716 107.385 107.995 107.825Z'
        className='fill-mono-color-white'
      />
      <path
        d='M63.7595 112.248C63.7576 114.238 63.038 116.159 61.7328 117.66C60.4275 119.162 58.6244 120.141 56.6548 120.42C54.6851 120.698 52.6812 120.256 51.0113 119.175C49.3413 118.094 48.1175 116.447 47.5647 114.536C47.0118 112.625 47.1671 110.579 48.002 108.774C48.8369 106.968 50.2953 105.525 52.1093 104.708C53.9233 103.892 55.9709 103.757 57.876 104.33C59.7811 104.902 61.4157 106.143 62.4794 107.824C63.317 109.147 63.761 110.682 63.7595 112.248Z'
        className='fill-brand-color-secondary-light'
      />
      <path
        d='M62.4794 107.825L54.3256 115.978C53.8131 115.184 50.958 111.497 50.958 111.497C51.3239 111.127 51.7144 110.783 52.1267 110.465L54.4943 113.622L61.5246 106.592C61.8811 106.972 62.2008 107.385 62.4794 107.825Z'
        className='fill-mono-color-white'
      />
    </svg>
  );
}
export { CalendarIllustration };
